module.exports = __webpack_public_path__ + "static/img/solution-content-img.6002e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-content-img.png
// module id = 9liA
// module chunks = 0